// hubspot config
// window.hubspotConfig gets injected by HubspotConfigHelper#hubspot_config_script_tag in the layout
// if that's not there (e.g. js tests), falls back to sandbox defaults
//
// usage: import { getPortalId, getFormId } from '../../config/hubspotConfig'

// sandbox defaults in case window.hubspotConfig isn't set (e.g. running js tests)
const DEFAULT_CONFIG = {
  portalId: '51399091',
  courseAppObjectId: '2-35638690',
  formIds: {
    inquiry: 'c4b02a12-045d-4b4e-b14b-cb9fea4b6e15',
    personalInfo: 'b98d478d-5421-4804-8f51-c10116291bd5',
    employment: 'bc2a07fb-3dcf-4095-a58f-3645f15e8756',
    interest: '87b5445a-8244-4aac-ab41-0a3837caa32c',
    essay: '9075f1cd-4857-4538-9243-8b09bd22893c',
    acceptance: '27a2845a-2677-4d19-92cf-153267978887'
  },
  hubCityLookupUrl: '/api/hubspot/hubcity_lookup',
  loadTrackingScript: false
};

const getConfig = () => {
  if (typeof window !== 'undefined' && window.hubspotConfig) {
    return window.hubspotConfig;
  }
  return DEFAULT_CONFIG;
};

export const getPortalId = () => getConfig().portalId;

export const getCourseAppObjectId = () => getConfig().courseAppObjectId;

// formName: inquiry, personalInfo, employment, interest, essay, acceptance
export const getFormId = (formName) => getConfig().formIds[formName];

export const getHubCityLookupUrl = () => getConfig().hubCityLookupUrl;
